import { Injectable } from "@angular/core";
import { ZipCodeIntegration } from "src/app/ui/models/domains/pbm/state/zip-code-integration.model.ts";
import { AbstractParser } from "../../parser";
@Injectable()
export class ZipCodeIntegrationParser extends AbstractParser<ZipCodeIntegration> {
  parse(payload: any): ZipCodeIntegration {
    const zipCodeIntegration = new ZipCodeIntegration();
    if (payload) {
      zipCodeIntegration.setZipCode(payload.ZipCode);
      zipCodeIntegration.setAddress(payload.Address);
      zipCodeIntegration.setNeighborhood(payload.Neighborhood);
      zipCodeIntegration.setLocality(payload.Locality);
      zipCodeIntegration.setStateCode(payload.StateCode);
    }
    return zipCodeIntegration;
  }
}
